export const blackPrimary = "";
export const yellowMain = "#FFBC00";
export const yellow300 = "#FFDD80";
export const yellow100 = "#FFF7E0";
export const black500 = '#141414';
export const black400 = "#555555";
export const black300 = "#B1B1B1";
export const black200 = "#D7D7D7";
export const blackBackground = "#222222";
